import { useCallback, useState } from 'react';
import { Fuel, Info } from 'lucide-react';
import { getMapStations } from '../api/endpoints';
import { useFilters } from '../app/FiltersContext';
import ErrorState from '../components/feedback/ErrorState';
import LoadingState from '../components/feedback/LoadingState';
import QuickFuelControls from '../components/filters/QuickFuelControls';
import FuelMap from '../components/maps/FuelMap';
import { useAsync } from '../hooks/useAsync';

export default function MapPage() {
  const { fuel, service } = useFilters();
  const [bounds, setBounds] = useState(null);
  const onBoundsChange = useCallback(v => setBounds(v), []);
  const key = bounds?.join(',') || '';
  const map = useAsync(() => getMapStations({ fuel, service, bounds: key || undefined, limit: 8000 }), [fuel, service, key]);

  return (
    <div className="mx-auto max-w-6xl px-0 pb-5 sm:px-6 sm:pt-8">
      <div className="grid min-w-0 min-h-[calc(100dvh-153px)] overflow-hidden bg-md-surface sm:min-h-[720px] sm:rounded-[40px_40px_16px_40px] lg:grid-cols-[350px_minmax(0,1fr)]">
        <aside className="z-10 min-w-0 bg-md-primary-container p-5 sm:p-7">
          <h1 className="mt-5 text-[2.35rem] font-medium leading-[1.03] tracking-[-0.04em] text-md-on-primary-container">Trova il distributore e apri il suo storico.</h1>
          <p className="mt-3 text-sm leading-6 text-md-on-primary-container">Il prezzo sul marker è quello disponibile per carburante e modalità selezionati.</p>
          <div className="mt-7 rounded-[28px_12px_28px_28px] bg-md-surface p-4">
            <QuickFuelControls showTerritory={false} compact />
          </div>
          <div className="mt-6 grid gap-3 text-xs leading-5 text-md-on-primary-container">
            <div className="flex items-start gap-2"><Fuel className="mt-0.5 h-4 w-4 shrink-0" /> Tocca il prezzo per vedere nome, posizione e link allo storico.</div>
            <div className="flex items-start gap-2"><Info className="mt-0.5 h-4 w-4 shrink-0" /> Le coordinate MIMIT possono essere mancanti o imprecise; quelle non plausibili sono escluse.</div>
          </div>
        </aside>

        <div className="relative min-h-[520px] min-w-0 bg-md-surface-container sm:min-h-[650px]">
          {map.loading && !map.data ? <LoadingState minHeight={520} /> : map.error ? <div className="p-5"><ErrorState error={map.error} onRetry={map.reload} /></div> : <FuelMap data={map.data} onBoundsChange={onBoundsChange} height="100%" />}
        </div>
      </div>
    </div>
  );
}
